const htmlDIV = document.querySelector('#b2bDocsParntersCimena').querySelector('div[name=body]');
// const typeDisplay = document.querySelector('#b2bDocsParntersCimena').querySelector('div[name=body]');
const mainTabPaneBTDataDisplay = document.querySelector('#b2bDocsParntersCimena').querySelector('button[name=typeDataDisplay]');

// import auth from '../tools/storage.js';

import tools from '../../tools/tools.js';
import constants from '../../tools/constants.js';

export default {

  cleanContainer() {
    htmlDIV.innerHTML = '';
  },

  drawMarkupInContainer(str){
    htmlDIV.innerHTML = str;
  },

  getNameCntUser(allCntUser, userID){
    for (let p = 0; p < allCntUser.length; ++p){
      if(allCntUser[p].id == userID)
        return allCntUser[p].name;
    }

    return '-';
  },


  getColorCntUser(allCntUser, userID){
    let colorsClass = [ 'light-blue',
                        'light-purple', 
                        'light-yellow', 
                        'light-coral',
                        'light-salmon',
                        'light-seagreen'];


    for (let p = 0; p < allCntUser.length; ++p){
      if(allCntUser[p].id == userID)
        return 'cloud-stack-' + colorsClass[p];
    }

    return 'cloud-stack-white';
  },

  getElement(item, index, allCntUser, lastOpen) {
    
    // console.log(item);

    let statusInfo = constants.statusB2BRequestCards.find(o => o.status == item.status);
    // console.log(statusInfo);

    return `<label class="reference-header oneLine${(lastOpen == item.id) ? ' lastOpened':''} "  requestID=${item.id}>
                <div class="reference-column" requestID=${item.id}>${index + 1}</div>
                <div class="  w-70 p-1"  requestID=${item.id}>${item.name}</div>
                <div class=" oneLine w-15 min-240 mr-1 ml-1 p-1"  requestID=${item.id} style="background-color:#${statusInfo.color}">${statusInfo.name}</div>
                <div class=" oneLine w-10 min-170 mt-1"  requestID=${item.id}>
                   <div  requestID=${item.id} class="user-label ${this.getColorCntUser(allCntUser,item.cntUserIDfk)}">${item.cntUserIDfk ? this.getNameCntUser(allCntUser, item.cntUserIDfk ) :'Не выбрано' }</div>
                </div>
            </label>`;
  },




  drawDataInContainer(data, allCntUser, ownID, lastOpen) {
    let htmlBodyInLoop = '';
    let countLocations = 0;

    if (parseInt(mainTabPaneBTDataDisplay.value) == 0)
    {
      this.cleanContainer();
      this.drawMarkupInContainer(`<label class="reference-header" >
                <div class="reference-column">№</div>
                <div class="reference-column w-70">Название </div>
                <div class="reference-column w-15  min-240 ">Статус </div>
                <div class="reference-column w-10  min-170 mr-1">Куратор </div>
            </label>`);

      data.filter((el) => el.status != 91).forEach((item, index) => htmlDIV.insertAdjacentHTML('beforeend', this.getElement(item, index, allCntUser, lastOpen)));
    } else {

        for (let i = 0; i < constants.statusB2BRequestCards.length; ++i) {
          if(!constants.statusB2BRequestCards[i].hidden){
            let localHtmlBody = '';
            let localCount = 0;
            let localCountLocations = 0;

            for (let k = 0; k < data.length; ++k) {
              if(data[k].status == constants.statusB2BRequestCards[i].status){
                if(mainTabPaneBTDataDisplay.value == 1)
                  localHtmlBody += `<div class="cloud-stack-request ${(lastOpen == data[k].id) ? ' lastOpened':''}" requestID=${data[k].id}> 
                                    <b  class="cloud-stack-request-name" requestID=${data[k].id}>${data[k].name }</b>
                                    кол-во площадок: ${data[k].countLocation ? data[k].countLocation : '0'} 
                                    <div  requestID=${data[k].id} class="user-label ${this.getColorCntUser(allCntUser,data[k].cntUserIDfk)}">${data[k].cntUserIDfk ? this.getNameCntUser(allCntUser ,data[k].cntUserIDfk ) :'Не выбрано' }</div>
                                </div>`;
                else if (mainTabPaneBTDataDisplay.value == 2)
                  localHtmlBody += `<div class="cloud-stack-request ${this.getColorCntUser(allCntUser,data[k].cntUserIDfk)}  ${(lastOpen == data[k].id) ? ' lastOpened':''}"   requestID=${data[k].id}> 
                                    <div class="cloud-stack-request-name" requestID=${data[k].id}>${data[k].name }</div>
                                   </div>`;
                else { //пиксельный стиль
                      localHtmlBody += `<div class="pixel-stack-request ${this.getColorCntUser(allCntUser,data[k].cntUserIDfk)}  ${(lastOpen == data[k].id) ? ' lastOpened':''} ${data[k].name ? '': ' RED'}"   requestID=${data[k].id}> 
                                          №${data[k].id} 
                                       </div>`;
                }
                


                localCountLocations += data[k].countLocation ? data[k].countLocation : 0;
                if(data[k].status != 91)
                  countLocations += data[k].countLocation ? data[k].countLocation : 0;
                
                ++localCount;
              }
            }
            // отрисовка столбца лля 1 и 2 типа !!! тип 3 - пиксель - он отдельно
            if(mainTabPaneBTDataDisplay.value == 1 || mainTabPaneBTDataDisplay.value == 2){
              htmlBodyInLoop += `<div class="stack-column ${ localCount ? '':' empty-stack' }"  style="background-color:#${constants.statusB2BRequestCards[i].color} !important" > 
                          ${localCount ? ( '<div class="stack-column-stiker">' + localCount + '</div>') :'' }
                           ${localCount ? ( '<div class="stack-column-stiker-locations">' + localCountLocations + '</div>') :'' }
                          <b>${constants.statusB2BRequestCards[i].name}</b>`;
              htmlBodyInLoop += localHtmlBody;
              htmlBodyInLoop += '</div>';
            } else {
              htmlBodyInLoop += `<div class="stack-column-pixel"  style="background-color:#${constants.statusB2BRequestCards[i].color} !important" > 
                          <small>${constants.statusB2BRequestCards[i].name}</small>`;
              htmlBodyInLoop += localHtmlBody;
              htmlBodyInLoop += '</div>';
            }
          }
        }
    
      let htmlBody = `<span>Всего заявок: ${data.filter((el) => el.status != 91).length} всего площадок: ${countLocations}</span> <div class="stacks">`;
      htmlBody += htmlBodyInLoop;
      htmlBody += '</div>';       
      // </div>  `;
        
      htmlDIV.innerHTML = htmlBody;

    }
  },

};
